export default "__VITE_ASSET__DCjA588n__"